// extracted by mini-css-extract-plugin
export default {"group":"group§R32UyQMqnJlAKoAMvzNa","KA_PASS":"KA_PASS§SFqgHJa6YtcLeSYp9Ium","KI_PASS":"KI_PASS§irHtG5dNLVzOgA6SOaOK","vouchers":"vouchers§Q_I_lXzHQonNXhDwU0Go"};